import { Button } from '@mui/material';
import styles from './index.module.scss';
import classNames from 'classnames';
import { useOnBoardingDrawer } from '../../OnBoardingDrawerProvider';
import NextAction from '../../OnBoardingDrawerAction/NextAction';
import { LoadingPlaceholder } from '../../../../../LoadingPlaceholder';
import useIntakeData from '../../../../../../services/intakeDataService';
import useRegisterMethods from '../../hooks/useRegisterMethods';
import { addedUserByTypeEnum } from '../../hooks/types';
import useMixpanel from '../../../../../../hooks/useMixpanel';
import { snakeCase } from 'lodash';

const SelectRegistrationMethod = () => {
  const { trackClick } = useMixpanel();
  const {
    setContextData,
    moveToStep,
    activeStep,
    contextData: { addedUserByType },
  } = useOnBoardingDrawer();
  const registerMethods = useRegisterMethods();
  const { isLoading } = useIntakeData();

  const selectMethod = (type: addedUserByTypeEnum) => {
    const selectedRegisterMethod = registerMethods.find((method) => method.type === type);
    setContextData({
      addedUserByType: type,
    });

    if (selectedRegisterMethod?.isGoToNextStep) {
      moveToStep(activeStep);
    }
  };

  const onSelect = (type: addedUserByTypeEnum) => {
    const selectedRegisterMethod = registerMethods.find((method) => method.type === type);
    trackClick({
      action: 'patient_registration_method',
      data: {
        method: snakeCase(selectedRegisterMethod?.text),
      },
    });
    selectMethod(type);
  };

  return (
    <LoadingPlaceholder isLoading={isLoading}>
      <div className="flex flex-col">
        <span className="text-neutrals-n-400 text-2xl">
          Choose a method to register your patient
        </span>
        <div className="flex mt-12 flex-col">
          {registerMethods.map((method) => {
            const Icon = method.Icon;
            return (
              <Button
                key={method.type}
                classes={{
                  root: classNames(
                    styles.regBtn,
                    'flex items-center mb-8 text-neutrals-n-400 justify-start',
                    {
                      [styles.selected]: addedUserByType === method.type,
                    },
                  ),
                }}
                startIcon={Icon ? <Icon /> : null}
                onClick={() => {
                  onSelect(method.type);
                }}
              >
                {method.text}
              </Button>
            );
          })}
        </div>
      </div>
      <NextAction
        testid={'select-reg-method-proceed'}
        onClick={() => moveToStep(activeStep)}
        disabled={!addedUserByType}
      />
    </LoadingPlaceholder>
  );
};

export default SelectRegistrationMethod;
